import AutoAwesomeRoundedIcon from "@mui/icons-material/AutoAwesomeRounded";
import ChevronRightRoundedIcon from "@mui/icons-material/ChevronRightRounded";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import EditNoteRoundedIcon from "@mui/icons-material/EditNoteRounded";
import {
  Box,
  ButtonBase,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Stack,
  Typography,
} from "@mui/material";

const methodSx = {
  width: "100%",
  minWidth: 0,
  minHeight: { xs: 164, sm: 190 },
  p: "24px !important",
  border: "1px solid #dfe3ea",
  borderRadius: "8px",
  bgcolor: "#fff",
  display: "grid",
  gridTemplateColumns: "minmax(0, 1fr) 32px",
  gridTemplateRows: "48px auto",
  columnGap: 2,
  rowGap: 2.5,
  alignItems: "center",
  textAlign: "left",
  transition: "border-color 160ms ease, background-color 160ms ease, box-shadow 160ms ease",
  "&:hover, &:focus-visible": {
    borderColor: "var(--method-color)",
    bgcolor: "var(--method-bg)",
    boxShadow: "0 6px 18px rgba(28, 35, 48, 0.07)",
  },
  "&.Mui-focusVisible": { outline: "2px solid var(--method-color)", outlineOffset: 3 },
  "@media (prefers-reduced-motion: reduce)": { transition: "none" },
};

const iconSx = {
  width: 48,
  height: 48,
  display: "grid",
  placeItems: "center",
  flexShrink: 0,
  borderRadius: "8px",
  bgcolor: "var(--method-bg)",
  color: "var(--method-color)",
  "& svg": { fontSize: 28 },
};

export const OssOrderCreateMethodDialog = ({ open, onClose, onManual, onAiUpload }) => (
  <Dialog
    open={open}
    onClose={onClose}
    maxWidth={false}
    fullWidth
    aria-labelledby="oss-create-method-title"
    PaperProps={{ sx: { borderRadius: "8px", overflow: "hidden", width: "calc(100% - 32px)", maxWidth: 740, m: 2 } }}
  >
    <DialogTitle component="div" sx={{ p: "26px 64px 22px 28px !important", borderBottom: "1px solid #e5e7eb" }}>
      <Typography id="oss-create-method-title" component="h2" sx={{ m: 0, fontSize: "24px !important", lineHeight: 1.4, letterSpacing: 0, fontWeight: 700, color: "#202938" }}>
        주문 등록
      </Typography>
      <IconButton
        aria-label="닫기"
        onClick={onClose}
        sx={{ position: "absolute", top: 23, right: 22, color: "#687282" }}
      >
        <CloseRoundedIcon />
      </IconButton>
    </DialogTitle>

    <DialogContent sx={{ p: { xs: "18px !important", sm: "24px 28px 28px !important" }, bgcolor: "#fafbfc" }}>
      <Stack sx={{ display: "grid", gridTemplateColumns: { xs: "1fr", sm: "repeat(2, minmax(0, 1fr))" }, gap: 2 }}>
        <ButtonBase onClick={onManual} sx={{ ...methodSx, "--method-color": "#28766c", "--method-bg": "#edf6f3" }}>
            <Box sx={iconSx}><EditNoteRoundedIcon /></Box>
            <ChevronRightRoundedIcon sx={{ fontSize: 26, color: "#939ba8", justifySelf: "end" }} />
            <Box sx={{ gridColumn: "1 / -1", minWidth: 0, overflowWrap: "anywhere" }}>
              <Typography sx={{ fontSize: "20px !important", lineHeight: 1.4, letterSpacing: 0, fontWeight: 700, color: "#202938" }}>직접 입력</Typography>
              <Typography sx={{ mt: 0.75, fontSize: "14px !important", lineHeight: 1.6, color: "#687282" }}>
                주문 · 품목 정보 입력
              </Typography>
            </Box>
        </ButtonBase>

        <ButtonBase onClick={onAiUpload} sx={{ ...methodSx, "--method-color": "#6658dc", "--method-bg": "#f3f0ff" }}>
            <Box sx={iconSx}><AutoAwesomeRoundedIcon /></Box>
            <ChevronRightRoundedIcon sx={{ fontSize: 26, color: "#939ba8", justifySelf: "end" }} />
            <Box sx={{ gridColumn: "1 / -1", minWidth: 0, overflowWrap: "anywhere" }}>
              <Typography sx={{ fontSize: "20px !important", lineHeight: 1.4, letterSpacing: 0, fontWeight: 700, color: "#202938" }}>AI 업로드</Typography>
              <Typography sx={{ mt: 0.75, fontSize: "14px !important", lineHeight: 1.6, color: "#687282" }}>
                발주서에서 정보 추출
              </Typography>
            </Box>
        </ButtonBase>
      </Stack>
    </DialogContent>
  </Dialog>
);
